module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/qnKMLa/tc-custom/9781646043705.jpg?1734280988076",
      "alt": "This image is the cover for the book Unofficial Hogwarts Cocktail Book"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Unofficial Hogwarts Cocktail Book\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Shake up some magical libations, creative cocktails, and spellbinding drinks inspired by the wonderful world of Harry Potter! What better way to celebrate your love of Hogwarts and its host of beloved characters than by bringing out your potions cauldron (or cocktail shaker) and mixing up a host of spectacular cocktails? Raise a toast in true wizarding world style with cocktails including:"), _c('br'), _c('br'), _vm._v(" Golden Poptail Balls"), _c('br'), _vm._v(" Headmaster’s Lemon Drop"), _c('br'), _vm._v(" Mad-Eye Lychee"), _c('br'), _vm._v(" Martini Tea"), _c('br'), _vm._v(" Leaf-Reading Earl Grey Cocktail"), _c('br'), _vm._v(" Boozy Knickerbocker"), _c('br'), _vm._v(" Glory Christmas Party Punch"), _c('br'), _vm._v(" And many more!"), _c('br'), _c('br'), _vm._v(" Bring your love for wizardry and magic into a coupe, tumbler, or highball glass with The Unofficial Hogwarts Cocktail Book—the perfect gift for any Potterhead. With 50 delicious drink recipes and spellbinding, full-color photographs, any fan of the boy who lived is sure to be stupefied. Bottoms up! ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bertha Barmann\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Ulysses Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0